import { Component, Input } from '@angular/core'
import { IPublicFileReceipt } from '@engineering11/files-web'
import { Observable } from 'rxjs'
import { IEmployer } from 'shared-lib'
import { EmployerStore } from '../../../employer.store'
import { FOOTER_LOGO_DEFAULTS } from './constants'

@Component({
  selector: 'employer-footer-logo',
  template: `
    <sdk-logo-manage
      *ngrxLet="employer$ as employer"
      [headerText]="headerText"
      [subHeaderText]="subHeaderText"
      [logoInfo]="logoInfo"
      [customerKey]="employer?.id"
      [logoUrl]="employer?.footerLogoImage?.url ?? undefined"
      (logoUploaded)="logoUpdated($event, employer!)"
      (logoDeleted)="logoDeleted(employer!)"
    ></sdk-logo-manage>
  `,
})
export class EmployerFooterLogoComponent {
  @Input() headerText = FOOTER_LOGO_DEFAULTS.headerText
  @Input() subHeaderText = FOOTER_LOGO_DEFAULTS.subHeaderText
  @Input() logoInfo = FOOTER_LOGO_DEFAULTS.logoInfo
  employer$: Observable<IEmployer | undefined> = this.employerStore.employer$

  constructor(private employerStore: EmployerStore) {}

  async logoUpdated(logo: IPublicFileReceipt, employer: IEmployer) {
    this.employerStore.onUpdateEmployer({ ...employer, footerLogoImage: logo })
  }

  async logoDeleted(employer: IEmployer) {
    this.employerStore.onUpdateEmployer({ ...employer, footerLogoImage: null })
  }
}
